//import React, { useState } from "react";
import React, { useEffect, useState, useRef, useContext } from "react";
import axios from "axios";

const ReactivateAccountModal = ({ isOpen, onClose }) => {
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [countdown, setCountdown] = useState(null);

    if (!isOpen) return null;

    const handleSubmit = async () => {

        setMessage("");

        if (!email) {
            setMessage("Please enter your email.");
            return;
        }

        // Basic email regex pattern 
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        // Check invalid format 
        if (!emailPattern.test(email)) {
            setMessage("Please enter a valid email address.");
            return;
        }

        setMessage("");


        try {

            const config = {
                headers: {
                    Authorization: `${process.env.REACT_APP_CONFIGURE_HEADERS_AUTHORIZATION}`,
                },
            };

            axios
                .post(`api/user/${email}/resendActivationEmail`, null, config)
                .then((result) => {
                    //console.log("activation email re-sent", result.data);
                    setMessage("If the account exists, an activation email has been sent.");

                    // Start countdown at 5 seconds 
                    setCountdown(5);

                    // Update countdown every second 
                    const interval = setInterval(() => {
                        setCountdown((prev) => { if (prev === 1) { clearInterval(interval); } return prev - 1; });
                    }, 1000);

                    // Auto-close after 5 seconds 
                    setTimeout(() => {
                        onClose();
                        setMessage("");
                        setEmail("");
                        setCountdown(null);
                    }, 5000);

                })
                .catch((error) => {
                    setMessage("Unable to process request. Please try again.");
                });

        } catch (err) {
            console.error("Reactivate error:", err);
            setMessage("An error occurred. Please try again.");
        }

    };

    return (
        <div className="modal-overlay">
            <div className="modal-content" style={{ paddingTop: "10px", paddingBottom: "20px" }}>
                <p>Enter your email to receive the activation link.</p>

                <div className="reactivate-input-wrapper" style={{ padding: "10px" }}>
                    <input
                        type="email"
                        className={`form-control reactivate-input ${message ? "is-invalid" : ""}`}
                        placeholder="Email address"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                handleSubmit();
                            }
                        }}

                    />
                </div>

                <div className="mt-3">
                    <button className="btn btn-primary" onClick={handleSubmit}>
                        Submit
          </button>

                    <button className="btn btn-secondary ml-2" onClick={onClose}>
                        Cancel
          </button>
                </div>

                {message && (
                    <p className="mt-3"
                        style={{
                            color: message.includes("activation email has been sent") ? "green" : "red"
                        }}
                    >{message}</p>
                )}

                {/* Countdown UI */}
                {countdown !== null && (
                    <p className="mt-2 text-muted">
                        This window will close in <strong>{countdown}</strong> seconds…
                    </p>
                )}

            </div>
        </div>
    );
};

export default ReactivateAccountModal;
